<div class="event-card-container">
  <div class="card-header">Convite Colaborador</div>
  <div class="card-content" [class.no-actions]="invitation.status === invitationStatusEnum.PENDING">
    <div class="event-info-area">
      <div class="event-title-area">
        <p>{{ invitation.event_title }}</p>
      </div>
      <div class="event-banner-area">
        <img [src]="loadEventImage(invitation.event.thumbnail)" alt="Banner do evento" />
      </div>
      <div class="event-details-area">
        <p>{{ invitation.event.start_date | date: "short" }} - {{ invitation.event.start_date | date: "shortTime" }}</p>
        @if (invitation.event.address; as address) {
          <p>{{ address.location_name }}</p>
          <p>{{ address.street }} - {{ address.number }}</p>
          <p>{{ address.city_name }} - {{ address.state }}</p>
        }
      </div>
    </div>
    <div class="actions-area">
      @if (invitation.status === invitationStatusEnum.PENDING) {
        <app-button (btnClick)="handleAcceptClick()" styleType="primary" [disabled]="isLoading">ACEITAR</app-button>
      } @else if (
        invitation.status === invitationStatusEnum.ACCEPTED &&
        (invitation.role === "manager" ||
          invitation.role === "observer" ||
          invitation.role === "pdv_portaria_coordenador")
      ) {
        <app-button [routerLink]="['/producer-area/event/', invitation.event_id]" styleType="primary">
          VISUALIZAR EVENTO
        </app-button>
      }
    </div>
    <div class="invite-info-area">
      <div class="email-area invite-info-field">
        <p><b>Email remetente: </b> {{ invitation.email }}</p>
      </div>

      <div class="phone-area invite-info-field">
        <p><b>Telefone: </b> {{ invitation.phone }}</p>
      </div>

      <div class="role-area invite-info-field">
        <p><b>Cargo: </b> {{ invitation.role | collaboratorRoleEnum }}</p>
      </div>

      <div class="status-area invite-info-field">
        <p>
          <b>Status: </b>
          <span class=" status status--{{ invitation.status.toLowerCase() }}">{{
            invitation.status | invitationStatusEnum
          }}</span>
        </p>
      </div>

      <div class="expiration-area invite-info-field">
        <p>
          <b>Data expiração: </b>
          {{ invitation.expires_at | date: "short" }}
        </p>
      </div>
    </div>
  </div>
</div>
